import {
  EXISTING_ENOAD_BATCH_COMPARISON_RESULT,
  GENERATED_ENOAD_BATCH_COMPARISON_RESULT,
  GENERATE_ENOAD_BATCH_MSG,
  GET_LEGS_LIST,
  SELECTED_PORT
} from '../constants/actionTypes'
import get from 'lodash/get'

const generatedEnoadBatchMsg = (store = {}, action = {}) => {
  switch (action.type) {
    case GENERATE_ENOAD_BATCH_MSG:
      return get(action, 'data.data', {}) || {}
    default:
      return store
  }
}

const existingEnoadComparisonResult = (store = {}, action = {}) => {
  switch (action.type) {
    case EXISTING_ENOAD_BATCH_COMPARISON_RESULT:
      return get(action, 'data.data', {}) || {}
    default:
      return store
  }
}

const generatedEnoadComparisonResult = (store = {}, action = {}) => {
  switch (action.type) {
    case GENERATED_ENOAD_BATCH_COMPARISON_RESULT:
      return get(action, 'data.data', {}) || {}
    default:
      return store
  }
}

const selectedPort = (store = [], action = {}) => {
  switch (action.type) {
    case SELECTED_PORT:
      return get(action, 'data', [])
    default:
      return store
  }
}

const voyageLegs = (store = [], action = {}) => {
  switch (action.type) {
    case GET_LEGS_LIST:
      return {
        legs: get(action, 'data.data', [])
      }
    default:
      return store
  }
}

export {
  generatedEnoadBatchMsg,
  existingEnoadComparisonResult,
  generatedEnoadComparisonResult,
  selectedPort,
  voyageLegs
}
